export function applyNestedForms(form, nestedFormsById) {
  var _form$fields;
  if (!form.nestedForms && !nestedFormsById) {
    return form;
  }
  const nestedFormsByTarget = getNestedFormsByTarget(form);
  return {
    ...form,
    fields: (_form$fields = form.fields) == null ? void 0 : _form$fields.map(field => {
      const fieldTarget = field.target;
      if (!fieldTarget) {
        return field;
      }
      const nestedFormId = field.nestedFormId;
      if (!nestedFormId) {
        return field;
      }
      const nestedForm = (nestedFormsByTarget == null ? void 0 : nestedFormsByTarget[fieldTarget]) ?? (nestedFormsById == null ? void 0 : nestedFormsById[nestedFormId]);
      if (nestedForm) {
        return {
          ...field,
          view: {
            ...field.view,
            form: nestedForm
          }
        };
      }
      return field;
    })
  };
}
export function getNestedFormsByTarget(form) {
  var _form$nestedForms;
  return (_form$nestedForms = form.nestedForms) == null ? void 0 : _form$nestedForms.reduce((byTarget, _ref) => {
    let {
      targets,
      form: nestedForm
    } = _ref;
    if (!nestedForm || !targets) {
      return byTarget;
    }
    for (const target of targets) {
      byTarget[target] = nestedForm;
    }
    return byTarget;
  }, {});
}
export function getNestedFormArray(formsByTarget) {
  return Object.keys(formsByTarget).map(target => {
    return {
      targets: [target],
      form: formsByTarget[target]
    };
  });
}
//# sourceMappingURL=apply-nested-forms.js.map